import React, {
  useEffect,
  useState,
  useReducer,
  useContext,
  useRef,
} from "react";
import moment from "moment";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

import { UserContext } from "../UserContext";

const {
  REACT_APP_ECLIPSE_API_PUBLIC,
  REACT_APP_ECLIPSE_API,
  REACT_APP_ECLIPSE_API_Local,
} = process.env;

const filter = createFilterOptions();

export default function FreeSoloCreateOptionDialog({
  setAC_SelectedData_CourierService,
  C_Title,
}) {
  // --------------------------------------- use context
  const contextValue = useContext(UserContext);

  // ------------------------------------------------- DB

  //
  const [DB_CourierList, setDB_CourierList] = useState([]);
  const get_DB_Courier_List = () => {
    axios
      .post(`${REACT_APP_ECLIPSE_API}/get_vlerp__courier_info__all`)
      .then((res) => {
        setDB_CourierList(res.data);
        console.log("get_DB_Courier_List", res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  //
  const add_DB_Courier_List = (
    _courier_name,
    _courier_contact,
    _courier_gen_by
  ) => {
    axios
      .post(`${REACT_APP_ECLIPSE_API}/add_vlerp__courier_info`, {
        courier_name: _courier_name,
        courier_contact: _courier_contact,
        courier_gen_by: _courier_gen_by,
      })
      .then((res) => {
        setDB_CourierList(res.data);
        console.log("add_DB_Courier_List", res.data);
        if (res.data.affectedRows > 0) {
          alert("New Courier Add Successfully ! ");

          setTimeout(() => {
            get_DB_Courier_List();
            handleClose();
          }, 2000);
        } else {
          alert("Failed to Add New Courier, Please contact Admin !");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // ------------------------------------------------- etc

  const [value, setValue] = React.useState(null);
  const [open, toggleOpen] = React.useState(false);

  const handleClose = () => {
    setDialogValue({
      courier_name: "",
      courier_contact: "",
    });

    toggleOpen(false);
  };

  const [dialogValue, setDialogValue] = React.useState({
    courier_name: "",
    courier_contact: "",
  });

  const handleSubmit = (event) => {
    console.log("hit");
    event.preventDefault();
    setValue({
      referer_id: selected_RefererID.current,
      courier_name: dialogValue.courier_name,
      courier_contact: parseInt(dialogValue.courier_contact, 10),
    });

    // // update parent
    setAC_SelectedData_CourierService({
      courier_name: dialogValue.courier_name,
      courier_contact: parseInt(dialogValue.courier_contact, 10),
    });

    // add to db
    add_DB_Courier_List(
      dialogValue.courier_name,
      parseInt(dialogValue.courier_contact, 10),
      contextValue.current.firebase_userInfo.email
    );
  };

  // ------------------------------------------------- Global Variable
  const selected_RefererID = useRef("NA");

  // ------------------------------------------------- useEffect

  useEffect(() => {
    get_DB_Courier_List();
  }, []);

  return (
    <React.Fragment>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({
                courier_name: newValue,
                courier_contact: "",
              });
              setAC_SelectedData_CourierService({
                courier_name: newValue,
                courier_contact: "",
              });
            });
          } else if (newValue && newValue.inputValue) {
            toggleOpen(true);
            setDialogValue({
              courier_name: newValue.inputValue,
              courier_contact: "",
            });
            setAC_SelectedData_CourierService({
              courier_name: newValue.inputValue,
              courier_contact: "",
            });
          } else {
            setValue(newValue);
            setAC_SelectedData_CourierService(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== "") {
            filtered.push({
              inputValue: params.inputValue,
              courier_name: `Add "${params?.inputValue}"`,
            });
          }

          return filtered;
        }}
        id="free-solo-dialog-demo"
        options={DB_CourierList}
        getOptionLabel={(option) => {
          // e.g value selected with enter, right from the input
          // console.log("option", option.id);
          selected_RefererID.current = option.id;
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.id == undefined
            ? option.courier_name
            : "(" + option.id + ") " + option.courier_name;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => (
          <li {...props}>
            <div>
              <div>{`(${option?.id}) ${option?.courier_name}`}</div>
              <div>{`ref : ${option?.courier_contact}`}</div>
            </div>
          </li>
        )}
        sx={{ width: "100%" }}
        freeSolo
        renderInput={(params) => <TextField {...params} label={C_Title} />}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        // fullScreen
        maxWidth="xl"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add a new Courier</DialogTitle>
          <DialogContent>
            <DialogContentText>..</DialogContentText>

            <div className="global_flex_column_cc gap_50">
              <TextField
                fullWidth
                autoFocus
                margin="dense"
                id="name"
                value={dialogValue.courier_name.split(")")[1]}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    courier_name: event.target.value,
                  })
                }
                label="Courier Name"
                type="text"
                variant="standard"
              />
              <TextField
                fullWidth
                margin="dense"
                id="name"
                value={dialogValue.courier_contact}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    courier_contact: event.target.value,
                  })
                }
                label="Courier Contact"
                type="number"
                variant="standard"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const sampleData = [
  { title: "The Shawshank Redemption", courier_contact: 1994 },
  { title: "The Godfather", courier_contact: 1972 },
];
